import angular from 'angular';
import insuranceFactFindGoals from './insuranceFactFindGoals';

export default angular
  .module('components.insuranceFactFindGoals', [])
  .component('insuranceFactFindGoals', insuranceFactFindGoals).name;
